import { Column } from "@/components";
import { ClearableSearchInput } from "@/components/ClearableSearchInput";

export const CompaniesFilters = ({
  name,
  setName,
}: {
  name: string;
  setName: (name: string) => void;
}) => {
  return (
    <Column className="items-start gap-4">
      {/* https://github.com/shadcn-ui/ui/issues/1562 */}
      <ClearableSearchInput
        containerClassName="w-[338px]"
        onChange={setName}
        placeholder="Search by company name"
        value={name}
      />
    </Column>
  );
};
